export const correlationTooltip =
    'Focus on mitigating the impact of risks to the activities that have the highest ‘impact on target’. ' +
    'These are likely activities which are central to the completion of the target activity, and currently have a high number of risks associated with them or their predecessors. ' +
    'Mitigating the impact of Risks towards these specific activities will bring the P20, P50 and P80 dates forwards. ';
